module.exports = __webpack_public_path__ + "static/media/sph.06d3bdf6.png";